import React from "react";

export function UiSidebarButton({
    testID,

    SvgComponent,
    icon,

    text,
    onClick = () => {},
    isSelected = false,
    isMarked = false,
    isBold = false,
    isIndented = false,
} = {}) {
    return (
        <div
            data-testid={testID}
            onClick={onClick}
            className={`
                d-flex
                align-items-center
                cp
                py-2
                c-cursor-default
                text-capitalize
                ${isSelected
                    ? "c-text-primary-dark-1 c-bg-grey-225"
                    : "c-hover-220"
                }

                flex-shrink-0

                position-relative

                ${isMarked && "c-bg-grey-240"}
            `}
        >
            <div className={`
                h-100
                position-absolute
                ${(isSelected || isMarked) && "c-left-thick-border"}
            `}>
                {isSelected &&
                    <div className="c-arrow-right" />
                }
            </div>

            {isIndented && <div className="c-sidebar-indent" style={{ marginLeft: "0.75rem" }}/>}
            {iconFn()}
            <div className="ml-3"/>
            {textFn()}
        </div>
    );

    function iconFn() {
        const sizeStyle = isBold
            ? { width: "1.75rem", height: "1.75rem" }
            : { width: "1.5rem", height: "1.5rem" };

        const dimStyle = !isBold ? { opacity: 0.75 } : {};

        const iconStyle = { ...sizeStyle, ...dimStyle };

        if (SvgComponent)
            return <SvgComponent
                className="c-fill-40 ml-3 flex-shrink-0"
                style={iconStyle}
            />;

        if (!icon) {
            return (
                <div
                    className="flex-shrink-0 ml-3"
                    style={sizeStyle}
                />
            );
        }

        return (
            <img
                className="ml-3 flex-shrink-0"
                style={iconStyle}
                src={icon}
                alt="sidebar icon"
            />
        );
    }

    function textFn() {
        return (
            <span className={`
                ${isBold || isSelected
                    ? "c-font-weight-medium"
                    : "c-font-weight-light c-text-110"
                }

                overflow-hidden
                text-nowrap
            `}>
                {text}
            </span>
        );
    }
}